import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-login-three',
  templateUrl: './auth-login-three.component.html',
  styleUrls: ['./auth-login-three.component.css']
})
export class AuthLoginThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
